import "core-js/modules/es6.array.is-array";
export function isNonEmptyArray(value) {
  return Array.isArray(value) && value.length > 0;
}